/*
  IaProvider allows for toggling between IA versions
  'V1' or 'V2' is stored in the 'currentIA' cookie
  Defaults to V2
*/
import Cookies from 'universal-cookie';
import V1 from './ia_map_v1';
import V2 from './ia_map_v2';
import { withCookieJar } from '../../utils/cookie_jar';

class IaProvider {
  static versions = { V1, V2 };

  constructor() {
    this.cookies = new Cookies();
    // Default current version to V1
    if (!this.currentIA) this.currentIA = 'V1';
  }

  get currentTheme() {
    return this.currentIA === 'V2'
      ? 'default'
      : 'v1';
  }

  // Run the IA function for the current version with supplied args
  load(...args) {
    return IaProvider.versions[this.currentIA](...args);
  }
}

export default withCookieJar(IaProvider, 'currentIA');



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/ia_map_manager.js